var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "layout",
    { attrs: { breadcrumbs: _vm.breadcrumbs } },
    [
      _c("template", { slot: "header" }, [
        _c("h1", { staticClass: "text-center" }, [
          _vm._v("\n            Select Trim\n        ")
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "d-sm-none mobile-header" },
        [
          _c("b-col", [
            _c("h1", { staticClass: "text-center" }, [
              _vm._v("\n                Select Trim\n            ")
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            {
              staticClass: "trims-list-container",
              attrs: { cols: "12", md: "7" }
            },
            [
              _c("trims-list", {
                attrs: { trims: _vm.trims },
                on: {
                  "compare-clicked": _vm.onCompareClick,
                  "view-all-options": _vm.openOptionsModal
                },
                model: {
                  value: _vm.selectedTrim,
                  callback: function($$v) {
                    _vm.selectedTrim = $$v
                  },
                  expression: "selectedTrim"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "d-none d-sm-block", attrs: { md: "5" } },
            [
              _vm.isLoading
                ? _c("vehicle-details-loader")
                : _c(
                    "affix",
                    {
                      style: { width: _vm.affixWidth },
                      attrs: {
                        "relative-element-selector": ".trims-list-container",
                        offset: { top: 60, bottom: 20 }
                      }
                    },
                    [
                      _vm.selectedTrim
                        ? _c("vehicle-details", {
                            attrs: {
                              trim: _vm.selectedTrim,
                              "base-trim": _vm.baseTrim
                            },
                            on: { "view-all-options": _vm.openOptionsModal }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
              _vm._v(" "),
              _vm.selectedTrim
                ? _c("standard-options-modal", {
                    ref: "optionsModal",
                    attrs: { trim: _vm.selectedTrim }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }